import {MainProfileResponseTypes} from 'appRedux/actions/profile/types';

export const isGeneralInfoPresented = (profile: MainProfileResponseTypes) => {
    return profile?.firstName && profile?.lastName;
};
